export default __webpack_public_path__ + "static/media/NL_parcours_3_carte_2.59bbc906.png";